module.exports = {
  RAILS_API_URL: 'https://aideal-api.appier.com',
  RAILS_API_PORT: 443,
  FACADE_API_URL: 'https://facade.zenclerk.com',
  FACADE_API_PORT: 443,
  ZC_APIKEY: 'emin-zcs',
  ZC_TAG_EVENT_PREFIX: 'zcs',
  AIDEAL_URL: 'https://aideal-app.appier.com',
  GRAPHQL_URL_APP: 'https://aideal-graphql.appier.com/graphql',
  GRAPHQL_URL_MASTER: 'https://aideal-graphql.appier.com/mgraphql',
  SENTRY_DSN: 'https://077b5ff63277b5defa204a88cb17f0e4@sentry.zenclerk.com/7',
  GA_TRACKING_ID: 'UA-46304525-2',
  INTERCOM_ENABLE: true,
  INTERCOM_APP_ID: 'h8jkve69',
  WEBPAY_PUBLIC_KEY: 'test_public_gj6etH6RV9zY3Ds8wP5n74xn',
  MAKEREPEATER_COOKIE: 'fueldid',
  MAKEREPEATER_LOGIN_URL: 'https://www.makerepeater.jp/auth/login',
  MAKEREPEATER_OEM_HOST: 'www.makerepeater.jp',
  MAKEREPEATER_API_URL: 'https://cvapi.makerepeater.jp',
  MAKEREPEATER_DOMAIN: 'makerepeater.jp',
  ENV: 'production',
  ENABLE_AUTH0: true,
};



// WEBPACK FOOTER //
// ./src/env.js